<template>
    <!--字段说明与样本数据-->
    <!-- <div v-if="loading" class='slider'>
                    <div class='line'></div>
                    <div class='subline inc'></div>
                    <div class='subline dec'></div>
                </div> -->
    <div>
        <!-- <div class="databaseIndex">
            <span class="databaseChineseName_span">
                对外直接投资
            </span>
            <span> - 中国境外投资企业 - 中国境外投资企业</span>
        </div> -->
        <div v-if="loading" class ='slider'><div class ='line'></div><div class ='subline inc'></div><div class ='subline dec'></div></div>
        <div v-else class="tabs">
             <!-- style="border-top: 1px solid rgb(204, 204, 204);" -->
            <div>
                <div class="fieldAndsampleData_div">
                    <div class="sampleData_div">
                        <div class="top_head">
                            <i class="iconfont icon-yangben"></i>
                            <span style="color:#4773bb">&nbsp;样本数据</span>
                        </div>
                        <div style="margin: 0 auto;">
                            <div class="sampleData_table_div scrollbars">
                                <table class="simpledata_table stickythead hoverline" cellspacing='0' cellpadding='0'>
                                    <thead class="theadDivBox">
                                        <tr v-if="headerList.length>0" style="background-color: #FFF;">
                                            <th style="height:39px;">序号
                                            </th>
                                            <th style="height:39px;" v-for="(item,index) in headerList1" :key="index">
                                                {{item}}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody class="tbodyDiv">
                                        <tr v-for="(item,index) in this.simpleData" :key="index">
                                            <td>
                                                {{index+1}}
                                            </td>
                                            <td v-for="(item1) in headerList" :key="item1+index">
                                                <span v-if="!((simpleData[index])[item1])"></span>
                                                <span v-if="(typeof ((simpleData[index])[item1])!='string') || item1.constructor!=String">{{(simpleData[index])[item1]}}</span>
                                                <span v-else-if="(simpleData[index])[item1].length<30">{{(simpleData[index])[item1]}}</span>
                                                <a class="colDetail"
                                                   @click="hideOtherPopover"
                                                   href="javascript:void(0);"
                                                   data-toggle="popover"
                                                   data-placement="bottom"
                                                   :data-content="(simpleData[index])[item1]"
                                                   v-else
                                                >点击查看</a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="fieldDescription_div ">
                      <div class="top_head" style="margin-top: 0px;">
                        <i class="iconfont icon-shuoming" style="font-size: 20px;"></i>
                        <span style="color:#4773bb">&nbsp;字段说明</span>
                      </div>


                      <div class="fieldDescription_table_div scrollbars">
                        <table class="descriptiontable table-bordered stickythead">
                          <thead>
                          <tr style="white-space: nowrap;">
                            <th style="text-align: center">
                              <span>序号</span>
                            </th>
                            <th>
                              <span>字段</span>
                            </th>
                            <th>
                              <span>字段标题</span>
                            </th>
                            <th colspan="3">
                              <span>字段说明</span>
                            </th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="(item,index) in this.$route.params.viewname === 'CFND_HighTrail' ? this.currentSystem['tableInfo'][this.$route.params.name].fields ? this.currentSystem['tableInfo'][this.$route.params.name].fields : this.currentSystem['tableInfo'][this.$route.params.name].Fields : this.currentTableInfo.fields ? this.currentTableInfo.fields : this.currentTableInfo.Fields" :key="item.FieldName">
                            <td style="text-align: center">{{index+1}}</td>
                            <td>{{item.key ? item.key : item.FieldName}}</td>
                            <td>{{item.title ?item.title  : item.DisplayName}}</td>
                            <td>{{item.description ? item.key === 'Dnumber' ? getParamsViewName() : item.description : item.Description}}</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>


<!--                        <div class="fieldDescription_table_div">-->
<!--                            <table class="fieldDescription_head_table">-->
<!--                                <thead>-->
<!--                                    <tr style="border-bottom:1px #c1c1c1 solid;height: 25px;">-->
<!--                                        <th style="width:52px;text-align:center;">-->
<!--                                            <span>序号</span>-->
<!--                                        </th>-->
<!--                                        <th style="width: 130px;">-->
<!--                                            <span style="padding-left:10px;">字段</span>-->
<!--                                        </th>-->
<!--                                        <th style="width: 129px;">-->
<!--                                            <span style="padding-left:10px;">字段标题</span>-->
<!--                                        </th>-->
<!--                                        <th>-->
<!--                                            <span style="padding-left:10px;">字段说明</span>-->
<!--                                        </th>-->
<!--                                    </tr>-->
<!--                                </thead>-->
<!--                            </table>-->
<!--                            <div class="fieldDescription_table_body_div">-->
<!--                                <table class="fieldDescription_body_table hoverline">-->
<!--                                    <tbody>-->
<!--                                        <tr v-for="(item,index) in this.currentTableInfo.fields" :key="item.FieldName">-->
<!--                                            <td style="text-align:center;width:52px;">{{index+1}}</td>-->
<!--                                            <td style="padding-left:10px;width:130px;">{{item.key}}</td>-->
<!--                                            <td style="padding-left:10px;width:129px;">{{item.title}}</td>-->
<!--                                            <td style="padding-left:10px;">{{item.description}}</td>-->
<!--                                        </tr>-->
<!--                                    </tbody>-->
<!--                                </table>-->
<!--                            </div>-->
<!--                        </div>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "../api/axios";
import { mapState } from "vuex";
export default {
    data(){
        return{
            simpleData: [],
            headerList:[],
            dataType:'',
            loading: true
        }
    },
    computed:{
        ...mapState(["SystemList"]),
        currentSystem() {
            if(this.SystemList[this.$route.params.viewname]){
                return this.SystemList[this.$route.params.viewname];
            }else{
                return {}
            }
        },
        currentTableInfo() {
            if(this.currentSystem && this.currentSystem["tableInfo"]){
                return this.currentSystem["tableInfo"][
                this.currentSystem.prefixName + "-" + this.$route.params.name
                ];
            }else{
                return {}
            }
        },
        headerList1(){
          if (this.$route.params.viewname === "CFND_HighTrail") {
            let temp = [];
            if (this.currentSystem["tableInfo"][this.$route.params.name].fields) {
              this.currentSystem["tableInfo"][this.$route.params.name].fields.forEach((items) => {
                temp.push(items.DisplayName);
              });
            } else {
              this.currentSystem["tableInfo"][this.$route.params.name].Fields.forEach((items) => {
                temp.push(items.DisplayName);
              });
            }
            return temp;
          } else {
            return this.headerList.map(s=>this.currentTableInfo['fields'].filter(x=>x.key===s)[0].title);
          }
        }
    },
    mounted: function() {
        this.dataType = this.$route.params.type;
        $(".simpledata_table").trigger('reflow');
        let data = { mokuai: this.currentSystem.system, type: this.$route.params.type };
        axios
          .get("/api/getSampleData?type="+this.$route.params.name+"&mokuai="+encodeURIComponent(this.currentSystem.system))
          .then(response => {
              this.simpleData = response.data.data
              this.headerList = [];
            if (this.$route.params.viewname === "CFND_HighTrail") {
              if (this.currentSystem["tableInfo"][this.$route.params.name].fields) {
                this.currentSystem["tableInfo"][this.$route.params.name].fields.forEach((items) => {
                  this.headerList.push(items.FieldName);
                });
              } else {
                this.currentSystem["tableInfo"][this.$route.params.name].Fields.forEach((items) => {
                  this.headerList.push(items.FieldName);
                });
              }

            } else {
              for (let i = 0; i < this.currentTableInfo.fields.length; i++) {
                this.headerList.push(this.currentTableInfo.fields[i].key);
              }
            }
              this.loading = false;
          })
          .catch(function(error) {
            console.log(error);
          });
    },
    methods:{
        hideOtherPopover(e) {
            $(e.currentTarget).addClass("thisPopover");
            var updateObjArray = $(".colDetail");
            for (var i = 0; i < updateObjArray.length; i++) {
                var oneObj = $(updateObjArray[i]);
                if (!oneObj.hasClass("thisPopover")) {
                if (
                    oneObj
                    .parent()
                    .find("div:first-child")
                    .hasClass("arrow")
                ) {
                    oneObj.click();
                }
                }
            }
            $(e.currentTarget).removeClass("thisPopover");
        },
      getParamsViewName() {
          return this.$route.params.viewname + "的文本序号"
      }
    },
    updated(){
      $('[data-toggle="popover"]').popover({
        template:
            '<div class="popover" style="font-family:微软雅黑;"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content" style="max-height:200px;overflow:auto;"></div></div>'
      });
    }
}
</script>

<style scoped>
.databaseIndex {
    height: 40px;
    width: 100%;
    overflow: hidden;
    font-size: 16px;
}

.databaseIndex span {
    position: relative;
    top: 15px;
}

.database_function_div .tabs {
    overflow: hidden;
    margin: 0 0 30px;
    width: 100%;
    float: left;
    padding-top: 15px;
}

.sampleData_div,.fieldDescription_div {
    border:1px solid rgba(223, 229, 240, 0.8);
    border-radius: 4px;
    margin:0 auto;
    margin-bottom: 20px;
}

.top_head {
    line-height: 31px;
    font-size: 16px;
    text-align: left;
    padding: 5px 20px;
  border-bottom: 1px solid rgba(223, 229, 240, 0.8);
}
.iconfont{
  font-size: 18px;
  vertical-align: middle;
  color: #4184f3;
}

.sampleData_table_div {
    overflow: auto;
    max-height: 480px;
}

.simpledata_table {
    width: 100%;
}

.theadDivBox th {
    white-space: nowrap;
    padding: 0 10px;
    height: 39px;
    text-align: center;
}

.tbodyDiv {
    background: #fff;
}

.tbodyDiv tr {
    height: 28px;
    text-align: center;
    border-bottom: 1px solid rgba(223, 229, 240, 0.8);
}

.tbodyDiv td {
    white-space: nowrap;
    padding: 0 10px;
}

.fieldDescription_div {
    margin-top: 15px;
    margin: 0 auto;
}

.fieldDescription_table_div {
    margin: 0 auto;
    overflow: auto;
    max-height: 500px;
}

.fieldDescription_head_table th {
    border-right: 1px solid rgba(223, 229, 240, 0.8);
}
.descriptiontable{
  margin-bottom: 0px;
  width: 100%;
}
.descriptiontable td,.descriptiontable th{
  border: 1px solid rgba(223, 229, 240, 0.8);
  padding: 6px 20px;
  text-align: left;
  color: #515a6e!important;
  vertical-align: middle;
}

.descriptiontable th{
  background:#f8f8f9 !important;
}

.fieldDescription_table_body_div {
    max-height: 503px;
    overflow: auto;
    position: relative;
    margin-top: 25px;
}

.fieldDescription_head_table {
    width: 100%;
    height: 25px;
    position: absolute;
    z-index: 10;
    font-size: 14px;
}

.fieldDescription_body_table {
    width: 100%;
    background-color: white;
}

.fieldDescription_body_table tr {
    height: 25px;
    border-bottom: 1px #c1c1c1 solid;
    border-right: 1px #c1c1c1 solid;
}

.fieldDescription_body_table td {
    height: 25px;
    border-right: 1px #c1c1c1 solid;
}
/* 鼠标经过表格行 */
.hoverline tbody tr{
  transition: ease all 0.2s;
  -webkit-transition: ease all 0.2s; /* Safari and Chrome */
  -moz-transition: ease all 0.2s; /* Firefox */
  -ms-transition: ease all 0.2s; /* Opera */
}
.hoverline tbody tr:hover {
  background-color: #f7f9ff;
  transition: ease all 0.1s;
  -webkit-transition: ease all 0.1s; /* Safari and Chrome */
  -moz-transition: ease all 0.1s; /* Firefox */
  -ms-transition: ease all 0.1s; /* Opera */
}
/* 固定表头 */
.stickythead{
  border-top: none !important;
}
.stickythead th{
  position: sticky;
  top: 0;
  background:#ecf2fe;
  border-top: none;
}

.sampleData_table_div::-webkit-scrollbar {
  width:5px;
}



</style>
